import axios from '../../../axios';
import { Field } from '../../ClientManagementSettings';

const url = 'invoicingservice/api/invoice-custom-field';

export const getAllInvoiceCustomFields = () => axios.get<Field[]>(url);
export const saveInvoiceCustomField = (field: Field) => axios.post(url, field);
export const getAllActiveInvoiceCustomFields = () => axios.get<Field[]>(`${url}/active`);
